import {Component, computed, input, model, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SelectModule} from 'primeng/select';
import {InputTextModule} from 'primeng/inputtext';
import {TranslocoPipe} from '@jsverse/transloco';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {DirectusTranslatedItem} from '@frontend/directus';
import {DirectusTooltipComponent} from '../../../directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-model-field-select',
  imports: [
    CommonModule,
    FormsModule,
    SelectModule,
    InputTextModule,
    TranslocoPipe,
    TranslateDirectusPipe,
    DirectusTooltipComponent,
  ],
  templateUrl: './model-field-select.component.html',
})
export class ModelFieldSelectComponent {
  id = input.required<string>();
  testId = input<string>('');
  label = input<string>('');
  tooltipKey = input<string>('');
  placeholder = input<string>('common.select');
  isReadOnly = input<boolean>(false);
  disabled = input<boolean>(false);
  smallLabel = input<boolean>(false);
  showClear = input<boolean>(true);
  filter = input<boolean>(false);

  options = input<any[] | DirectusTranslatedItem[]>([]);
  optionLabel = input<string>('name');
  optionValue = input<string>('id');

  isRequired = input<boolean>(false);
  invalid = input<boolean>(false);

  value = model<any>();

  protected readonly isTouched = signal<boolean>(false);

  protected readonly showInvalid = computed<boolean>(
    () => this.isTouched() && (this.invalid() || (this.isRequired() && this.value() == null)),
  );

  readonly resolvedTestId = computed<string>(() => this.testId() || `${this.id()}-input`);

  readonly clearable = computed(() => this.showClear() && !this.isRequired());

  readonly isDirectusMode = computed(() => {
    const firstOpt = this.options()?.[0];
    return !!(firstOpt && Array.isArray((firstOpt as DirectusTranslatedItem).translations));
  });

  readonly filterField = computed<string>(() =>
    this.isDirectusMode() ? 'filterText' : this.optionLabel(),
  );

  readonly selectedOption = computed(() => {
    const currentVal = this.value();
    const opts = this.options();
    const valKey = this.optionValue();
    if (!opts || opts.length === 0 || currentVal == null) return null;
    return opts.find((opt) => opt[valKey] === currentVal) ?? null;
  });

  protected markAsTouched(): void {
    this.isTouched.set(true);
  }
}
